import React, { useState, useEffect } from "react";
import { Link } from "react-scroll";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolling, setScrolling] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolling(true);
      } else {
        setScrolling(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`fixed w-full py-4 px-6 flex justify-between items-center z-50 transition-all duration-300 ${
        scrolling ? "bg-gray-900 shadow-lg text-white" : "bg-transparent text-gray-900"
      }`}
    >
      {/* Clickable Name to Scroll to Home */}
      <h1 className="text-2xl font-bold cursor-pointer transition-all hover:text-purple-400">
        <Link to="home" smooth={true} duration={500}>
          Sri Deepthi Vootla
        </Link>
      </h1>

      {/* Desktop Navbar */}
      <ul className="hidden md:flex space-x-6 font-semibold">
        {["Home", "About", "Experience", "Projects", "Contact"].map((section) => (
          <li key={section}>
            <Link
              to={section.toLowerCase()}
              smooth={true}
              duration={500}
              className="cursor-pointer hover:text-purple-400 transition-all"
            >
              {section}
            </Link>
          </li>
        ))}
      </ul>

      {/* Mobile Navbar */}
      <button className="md:hidden text-2xl" onClick={() => setIsOpen(!isOpen)}>
        ☰
      </button>

      {isOpen && (
        <div className="absolute top-16 right-6 bg-gray-900 text-white shadow-lg p-4 rounded-lg md:hidden">
          <ul className="flex flex-col space-y-4">
            {["Home", "About", "Experience", "Projects", "Contact"].map((section) => (
              <li key={section}>
                <Link
                  to={section.toLowerCase()}
                  smooth={true}
                  duration={500}
                  className="cursor-pointer hover:text-purple-400 transition-all"
                  onClick={() => setIsOpen(false)}
                >
                  {section}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}
    </nav>
  );
};

export default Navbar;